<template><div><h1 id="corris-import-linktabelle" tabindex="-1"><a class="header-anchor" href="#corris-import-linktabelle"><span>Corris-Import: Linktabelle</span></a></h1>
<p>Corris-Import: Linktabelle — Zuordnung Corris-Adresse/funtrade-Adresse</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Linktabelle ist die Basis für den Import/Export der von Corris angelieferten Adress- und Mitgliederdaten. Neben der Zuordnung der Corris-Personen-ID zu der funtrade-Personen-ID sind auch Import-/Export- und Mutationsdaten gespeichert, welche für die Steuerung des Imports und die Produktion der Corris-Mutationsliste wichtig sind. Die Daten können nicht manuell editiert werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Verarbeitungsläufe → Corris-Schnittstelle → Personenlinks Corris - funtrade</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr. Corris</dt>
<dd>Von Corris gelieferte Personen-ID der Quelldaten.</dd>
<dt>Nr. funtrade</dt>
<dd>Personen-ID der funtrade-Adresse, die beim Import angelegt/zugeoordnet worden ist.</dd>
<dt>Adresse</dt>
<dd>Name und Adresse in funtrade</dd>
<dt>importiert am</dt>
<dd>Datum/Zeit des letzten Imports</dd>
<dt>exportiert am</dt>
<dd>Datum/Zeit des letzten Exports</dd>
<dt>geändert am</dt>
<dd>Datum/Zeit der letzten Änderung (wichtig für die Produktion der Mutationsliste)</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.corrisimport.html">Corris-Import</RouteLink>.</p>
</div></template>


